import users from './userData'

const fakeData = [...users];

export default fakeData;